export default __webpack_public_path__ + "static/media/gojelly-white.015df244.png";